/**
 * `browse_deal` / `search_catalog` return markdown built for the LLM that
 * embeds internal addressing (`[doc_id]`, `[file_id:N]`, snake_case
 * document_type tokens). Strip the identifiers and humanize the type tokens
 * before showing this to the customer.
 */
export function summarizeCatalogMarkdown(summary: string): string | null {
	if (!summary || !summary.includes("Deal:")) return null;
	let out = summary;
	out = out.replace(/\s*\[[a-z0-9]+__[a-z0-9_-]+\]/gi, "");
	out = out.replace(/\s*\[file_id:\d+\]/gi, "");
	out = out.replace(
		/(- [^\n|]+? )([a-z]+(?:_[a-z]+)+)(\s*(?:\||$))/gm,
		(_m, prefix: string, token: string, suffix: string) =>
			`${prefix}${token
				.split("_")
				.map((s) => s.charAt(0).toUpperCase() + s.slice(1))
				.join(" ")}${suffix}`,
	);
	return out.trim();
}
